@if (posvc.loading()) {
  <p-progress-bar mode="indeterminate" [style]="{ height: '4px' }"></p-progress-bar>
} @else {
  @if (data.positions) {
    <div class="form-row flex-align-center">
      <label>
        {{ Yii.t('app', 'Positions') }}
      </label>
      <div>
        <ng-select
          style="width: 100%"
          [items]="positions"
          [multiple]="true"
          bindLabel="name"
          [hideSelected]="true"
          appendTo="body"
          [(ngModel)]="data.positions"
          (change)="sync()"
          placeholder="Select Position...">
        </ng-select>
      </div>
    </div>

    <div class="form-row flex-align-center">
      <label>
        {{ Yii.t('app', 'Show submitted to additional positions') }}
        @if (data.additional.show_in_target_branch) {
          <span style="color: red">*</span>
        }
      </label>
      <div>
        <ng-select
          [items]="positions"
          [multiple]="true"
          bindLabel="name"
          [hideSelected]="true"
          appendTo="body"
          [(ngModel)]="data.view_positions"
          (change)="sync()"
          placeholder="Select Position...">
        </ng-select>
      </div>
    </div>

    <div class="form-row">
      <label>
        {{ Yii.t('app', 'Show in target branch also') }}
      </label>
      <div class="flex-row gap-8px">
        <p-checkbox
          binary="true"
          [(ngModel)]="show_in_target_branch"
          (change)="sync()"
        />
        <div>
          <div>
            ({{ Yii.t('app', 'only to the above positions') }})
          </div>
        </div>
      </div>
    </div>
    @if (data.additional.show_in_target_branch === 1 && data.view_positions.length === 0) {
      <div class="form-row">
        <label></label>
        <div style="color: red">
          {{ Yii.t('app', 'At least one position needs to be set if the "Show In Target Branch" is checked.') }}
        </div>
      </div>
    }
    <div class="form-row">
      <label></label>
      <div style="color: red">
        {{ Yii.t('app', '* position filter and target branch settings applicable to BOSS forms only') }}
      </div>
    </div>
  }
}
